import { useMutation } from '@tanstack/react-query';

import { fetchJson } from '../fetch';

type Payload = {
  emailAddress: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
};

export const useCreateUncompletedRegistration = () => {
  return useMutation({
    mutationFn: (body: Payload) => {
      return fetchJson('/registration/notify-sales-team', {
        method: 'POST',
        body,
      });
    },
  });
};
